<template>
  <div>
    <b-modal
      v-model="open"
      no-close-on-backdrop
      no-close-on-esc
      size="lg"
    >
      <template #modal-header>
        <h5>Configuração do node</h5>
        <b-button size="sm" variant="danger" @click="closeDialog()">
          X
        </b-button>
      </template>

      <template>
        <b-form  @submit.stop.prevent>
          <b-input-group>
            <b-input-group-prepend is-text>
              Título
            </b-input-group-prepend>
            <b-form-input
              id="title-input"
              v-model="title"
              :state="titleRules"
              :readonly="wfPublished"
            ></b-form-input>
          </b-input-group>
          <b-form-invalid-feedback :state="titleRules">
            O título não pode estar vazio.
          </b-form-invalid-feedback>
        </b-form>

        <br/>

        <b-form  @submit.stop.prevent>
           <b-input-group>
            <b-input-group-prepend is-text>
              Modelo do formulário
            </b-input-group-prepend>
            <b-form-input 
              list="form-list-id"
              v-model="selectedForm"
              :state="formRules"
              :readonly="wfPublished"
              @focus="updateFormList()"
            ></b-form-input>
            <b-button 
              class="createBtn" 
              size="sm"
              :disabled="wfPublished"
              @click="openNewActionLink()"
            >
              Criar
            </b-button>

            <datalist id="form-list-id">
              <option v-for="form in formList" :key="form.id">{{ form.title ? form.title : '' }}</option>
            </datalist>
          </b-input-group>
          <b-form-invalid-feedback :state="formRules">
            Selecione um modelo de formulário.
          </b-form-invalid-feedback>
        </b-form>

        <br/>

        <b-form
          v-show="!entryGateway"
          @submit.stop.prevent
        >
          <b-input-group>
            <b-input-group-prepend is-text>
              Sequência do Kanban
            </b-input-group-prepend>
            <b-form-input
              id="sequence-input"
              v-model="sequence"
              :state="sequenceRules"
              :readonly="wfPublished"
              type="number"
            ></b-form-input>
          </b-input-group>
          <b-form-invalid-feedback :state="sequenceRules">
            A sequência do node não pode estar vazio e deve ser maior ou igual 0.
          </b-form-invalid-feedback>
        </b-form>
      </template>

      <template #modal-footer>
        <b-button
          v-if="!wfPublished"
          size="sm" 
          variant="success" 
          @click="saveChanges()"
        >
          Salvar
        </b-button>

        <div
          v-else
        >
          <span
            style="font-size: small; color: grey;"
          >
            Edição bloqueada, devido ao estado atual do workflow ser
          </span>
          <span
            style="font-size: small; font-weight: 800; color: grey;"
          >
            Publicado.
          </span>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import store from '@/store'

export default {
  name: 'dialogSendForm',

  props: {
   open: {
     type: Boolean,
     default: false,
   },
   node: {
     type: Object,
     default: null,
   }
  },

  data() {
    return {
      selectedForm: null,
      title: '',
      sequence: 0,
      nodeInfo: null,
      formList: [],
    };
  },

  async mounted(){
    await this.setNodeInfo()
    this.updateFormList()
  },

  computed: {
    authInfo: () => store.getters.authInfo,

    intranetUrl: () => store.getters.intranetUrl,

    wfPublished: () => store.state.isPublished,

    titleRules() {
      return this.title ? this.title.length > 0 : false
    },
    sequenceRules() {
      return Number(this.sequence) > -1 ? true : false
    },
    formRules() {
      let result = false
      if (this.formList.length > 0){
        result = this.formList.find(el => el.title === this.selectedForm)
      }
      return result ? true : false
    },
    entryGateway(){
      let node = this.node.definition.incoming ? this.node.definition.incoming[0].sourceRef : false
      if (node && node.$type === 'bpmn:ExclusiveGateway'){
        return true
      } 
      return false
    },
    rules(){
      return [
        this.formRules,
        this.titleRules,
        this.sequenceRules
      ]
    }
  },

  watch: {
   formList: function(){
     if (this.formList && this.formList.length > 0){
       let findForm = this.formList.find(el => el.id === Number(this.nodeInfo.res_id))
       this.selectedForm = findForm ? findForm.title : null
     }
   },

   open: function(){
     if (this.open){
       this.fillfields()
     }
   }
  },
  
  methods: {
    async saveChanges(){
      if (this.checkFormValidity() === false) {
        return
      }
      await this.putNode()
      if (this.selectedForm){
        let findForm = this.formList.find(el => el.title === this.selectedForm)
        if (findForm){
          store.dispatch("putAction", {
            model: "intranet.workflow.action.execute.form",
            token: this.authInfo.token,
            id: findForm.id,
            payload: {
              workflow_id: this.authInfo.workflowId
            }
          })
        }
      }
      this.updateNode()
      this.$emit("saveChanges")
      this.$emit("close")
    },

    async updateFormList(){
      this.formList = await store.dispatch('getActionSendForm', {
        fields: "['id', 'title']",
        token: this.authInfo.token,
        domain: `'|', ('workflow_id', '=', ${this.authInfo.workflowId}), ('workflow_id', '=', False)`,
      })
    },

    async setNodeInfo(){
      let nodeData = await store.dispatch('getNode', {
        fields: "['id', 'title', 'sequence', 'res_model', 'res_id']",
        domain: "('id', '=', " + this.node.definition.$attrs.backId + ")",
        token: this.authInfo.token,
      })
      if (nodeData){
        this.nodeInfo = nodeData[0]
        this.fillfields()
      }
    },

    openNewActionLink(){
      window.open(this.intranetUrl + "/workflow/action_type/action_form_list#new", "_blank")
    },

    updateNode(){
      this.node.definition.name = `(${this.sequence})\n ${this.title}`
    },

    fillfields(){
      if (this.nodeInfo){
        this.title = this.nodeInfo.title
        this.sequence = this.nodeInfo.sequence
        if (this.formList.length > 0){
          let findForm = this.formList.find(el => el.id === Number(this.nodeInfo.res_id))
          this.selectedForm = findForm ? findForm.title : null
        }
      }
    },

    async putNode(){
      let form = this.formList.find(el => el.title === this.selectedForm)
      await store.dispatch('putNode', {
        payload: {
          title: this.title,
          sequence: this.sequence,
          res_model: 'intranet.workflow.action.execute.form',
          res_id: form.id
        },
        id: this.node.definition.$attrs.backId,
        token: this.authInfo.token,
      })
    },
    
    closeDialog(){
      this.$emit("close")
    },
    
    checkFormValidity() {
      return this.rules.find(el => el === false)
    },
  },
};
</script>
<style scoped>
.createBtn{
  width: 80px;
  margin-left: 20px;
  background-color: #0092ff;
}
</style>
